class EditPickupPointController {
  /* @ngInject */
  constructor($scope, $element, $rootScope, CatalogService, StorageService, MenuActions, PickupPointService, ProductsActions, ProductsStore, StoreStates, FoundationApi) {
    const that = this;

    this.isSuperAdmin = StorageService.getLocalStorage('superAdmin');

    that.loading = {
      pickupPoint: false,
    };

    this.resetModal = () => {
      that.productImage.isCrop = false;
      that.productImage.coverImage = '';
    };

    const init = () => {

      console.log('edit', that, this.onCancel2);

      if (that.mode === 'create') {
        that.pickupPoint = {
          vasId: this.vasId,
          name: null
        };
      } else if (that.mode === 'edit') {
      }

    };

    that.$onInit = init;


    that.savePickupPoint = () => {
      that.loading.product = true;

      switch (that.mode) {
        case 'create':
        default:
          PickupPointService.createPickupPoint(that.vasId, that.pickupPoint).then((response) => {
            console.log('createProduct response', response);
            this.onCancel();
          });
          break;
        case 'edit':
          PickupPointService.editPickupPoint(that.pickupPoint).then((response) => {
            console.log('editPickupPoint response', response);
            this.onCancel();
          });
          break;
      }
    };
  }
}

export default EditPickupPointController;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/orderAndPay/pickupPoint/edit/edit.controller.js
 **/